import { useMutation } from '@tanstack/react-query';

import { DocumentRelationObject } from '../../../../types';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { deleteDocumentRelation } from '../../requests/deleteDocumentRelation';
import { DocumentParams } from '../../types/DocumentParams';

export const useDeleteDocumentRelation = (documentParams: DocumentParams) => {
  const { constructDelete } = useRequestConstructor();

  const { mutateAsync: deleteRelation, ...rest } = useMutation({
    mutationFn: ({
      documentId,
      data,
    }: {
      documentId: string;
      data: DocumentRelationObject;
    }) =>
      deleteDocumentRelation(constructDelete, documentId, documentParams, data),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Delete failed')),
  });

  return { deleteRelation, ...rest };
};
